import styled,{keyframes} from "styled-components";
import { fadeInRight, fadeInUp } from "react-animations";
import { MdArrowForward, MdKeyboardArrowRight  } 
from "react-icons/md";

export const HeroContainer = styled.div`
background : #0c0c0c;
display : flex;
justify-content : center;
align-items : center;
padding : 0 30px;
height : 800px;
position : relative;
z-index : 1;

:before {
    content : '';
    position : absolute;
    top: 0;
    bottom : 0;
    right : 0;
    left : 0;
    background: linear-gradient(
        180deg, 
        rgba(0, 0, 0, 0.2) 0%, 
        rgba(0, 0, 0, 0.6) 100%
        ), 
    linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%);
    z-index : 2;
}
@media screen and (max-width : 768px){
    flex-direction : row;
}
`;

export const HeroBackground = styled.div`
position : absolute;
top : 0;
right : 0;
bottom : 0;
left : 0;
width : 100%;
height : 100%;
overflow : hidden;
background-attachment: fixed;
background : url('https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1502&q=80');
@media screen and (max-width : 768px){
   display : none;
};
`

export const HeroContent = styled.div`
z-index : 3;
max-width : 1000px;

padding : 8px 30px;
display : flex;
flex-direction : column;
align-items : left;
`
const fadeInRightAnimation = keyframes`${fadeInRight}`; 

export const HeroH1 = styled.h1`
color : #fff;
font-size : 48px;
text-align : left;
animation : 1s ${fadeInRightAnimation};
@media screeen and ( max-width : 768px) {
    font-size : 40px;
}
@media screen and ( max-width : 480px ){
    font-size : 32px;
}
`
const fadeInBottomAnimation = keyframes`${fadeInUp}`;
export const HeroP = styled.p`
margin-top : 24px;
color : #01bf71;
font-size : 20px;
text-align : left;
max-width : 600px;
animation : 1s ${fadeInBottomAnimation};

@media screen and ( max-width : 768px ) {
    font-size : 24px;
}

@media screen and ( max-width : 480px ) {
    font-size : 18px;
}
`
export const HeroSubTitle = styled.p`
margin-top : 12px;
color : #01bf71;
font-size : 13px;
text-align : left;
max-width : 600px;
animation : 1s ${fadeInBottomAnimation};

@media screen and ( max-width : 768px ) {
    font-size : 12px;
}

@media screen and ( max-width : 480px ) {
    font-size : 12px;
}
`

export const HeroBtnWrapper = styled.div`
margin-top : 32px;
display : flex;
flex-direction : column;
align-items : center;
`

export const ArrowForward = styled(MdArrowForward)`
margin-left : 8px;
font-size : 20px;
`

export const ArrowRight = styled(MdKeyboardArrowRight)`
margin-left : 8px;
font-size : 20px; `

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const BubblesDiv = styled.div`
position: fixed;
opacity : 0.7;
height : 80px;
top: 50vh;
left: 0;
z-index: 50;
transform: translate(-50%, -60%);
`

export const BubbleImg = styled.img`
animation: ${rotate} 10s linear infinite;
height : 300px;
width : 300px;`

export const ProfilePic = styled.img`
height : 300px;
width : 300px;
align-items: flex-start;
word-break:none;
border-radius : 50%;
`
export const HandlingHero = styled.div`
display : flex;
flex-direction : row-reverse;
z-index : 5;
@media screen and ( max-width : 768px ) {
flex-direction : column;
}`